import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
/**
 * Modal wrapper component.
 * @class
 */
@Component({
	selector: 'modal-wrapper',
	templateUrl: './modal-wrapper.component.html',
	styleUrls: ['./modal-wrapper.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalWrapperComponent {
	/**
	 * Input variable for providing 'title' value to component from parent.
	 */
	@Input() title = '';
	/**
	 * Input variable for providing 'content class' value to component from parent.
	 */
	@Input() contentClass = '';
	/**
	 * Input variable for providing 'actions panel class' value to component from parent.
	 */
	@Input() actionsPanelClass = '';
	/**
	 * Output variable for emitting 'close modal' value from component to parent.
	 */
	@Output() closeModal = new EventEmitter<void>();
}
